import type { AiChatReportPage } from '@ztechapps/common.contract'
import { WhatsNewModal, WhatsNewProvider } from '@ztechapps/blog.webui'
import { OrderPivotReportEnum } from '@ztechapps/common.contract'
import { OpenPivotProvider } from '@ztechapps/webui.reporting'
import { OpenReplayUserIdentifier } from '@ztechapps/webui.telemetry'
import Header from './header'
import { KeyboardShortcutProvider } from '@ztechapps/webui.util'
import { HasAppAccessPrivateLayout } from '@ztechapps/webui.page'
import { NativeNotificationListener } from '@ztechapps/webui.data-tools'
import { AppSettingKey } from '../config/AppSettingKey'
import { shortcutDefaults } from '../config/shortcutDefaults'
import { registerAllModules } from 'handsontable/registry'
import { routesDef } from '../config/routes'
import { AdminChatBubble } from './chat-bubble/AdminChatBubble'
import { ChatBubbleVisibilityProvider } from './chat-bubble/Context'
import { panelpunchesPermissions } from '@ztechapps/panelpunches.common'

registerAllModules()

const PIVOT_REPORT_PAGES: AiChatReportPage[] = [
  {
    report: OrderPivotReportEnum.orderPivotReport,
    title: routesDef.ReportOrderPage.name,
    path: routesDef.ReportOrderPage.path,
  },
  {
    report: OrderPivotReportEnum.openOrderPivotReport,
    title: routesDef.ReportOpenOrderPage.name,
    path: routesDef.ReportOpenOrderPage.path,
  },
  {
    report: OrderPivotReportEnum.closedOrderPivotReport,
    title: routesDef.ReportClosedOrderPage.name,
    path: routesDef.ReportClosedOrderPage.path,
  },
  {
    report: OrderPivotReportEnum.orderWithProductsPivotReport,
    title: routesDef.ReportOrderWithProductsPage.name,
    path: routesDef.ReportOrderWithProductsPage.path,
  },
  {
    report: OrderPivotReportEnum.productPivotReport,
    title: routesDef.ReportProductPage.name,
    path: routesDef.ReportProductPage.path,
  },
  {
    report: OrderPivotReportEnum.inventoryPivotReport,
    title: routesDef.ReportInventoryPage.name,
    path: routesDef.ReportInventoryPage.path,
  },
  {
    report: OrderPivotReportEnum.inventoryBySerialNumberPivotReport,
    title: routesDef.ReportInventoryBySerialNumberPage.name,
    path: routesDef.ReportInventoryBySerialNumberPage.path,
  },
  {
    report: OrderPivotReportEnum.customerPivotReport,
    title: routesDef.ReportCustomerPage.name,
    path: routesDef.ReportCustomerPage.path,
  },
]

export default function PrivateLayout() {
  return (
    <KeyboardShortcutProvider appSettingKey={AppSettingKey.KEYBOARD_SHORTCUTS} defaultShortcuts={shortcutDefaults}>
      <OpenReplayUserIdentifier />
      <ChatBubbleVisibilityProvider>
        <OpenPivotProvider reportPages={PIVOT_REPORT_PAGES}>
          <WhatsNewProvider landingPath={routesDef.OverviewPage.path}>
            <HasAppAccessPrivateLayout
              hasAppAccessPermission={panelpunchesPermissions.storeBack.canAccess.value}
              header={
                <>
                  <Header />
                  <NativeNotificationListener />
                </>
              }
            />
            <WhatsNewModal />
          </WhatsNewProvider>
          <AdminChatBubble />
        </OpenPivotProvider>
      </ChatBubbleVisibilityProvider>
    </KeyboardShortcutProvider>
  )
}
